const cookieUtil = {
  /**
   * 设置值到cookie,(路径为path)
   * @param {*} key
   * @param {*} value
   * @param {*} expires 有效时间（单位小时）,不传默认浏览器关闭时失效
   * @param {*} path cookie携带路径
   */
  set(key, value, expires, path = '/', domain, secure) {
    var exdate = new Date()
    exdate.setDate(exdate.getHours + expires)
    let data = key + '=' + escape(value)
    data += '; path=' + path
    data += expires ? '; expires=' + exdate.toGMTString() : ''
    data += domain ? '; domain=' + domain : ''
    data += secure ? '; secure=' + secure : ''
    document.cookie = data
  },

  /**
   * 获取cookie中的值,不存在或已经过期则返回空
   * 返回为null代表过期或是没有值
   * @param {*} key
   */
  get(key) {
    //先查询cookie是否为空，为空就return ""
    if (document.cookie.length > 0) {
      //通过String对象的indexOf()来检查这个cookie是否存在，不存在就为 -1
      let start = document.cookie.indexOf(key + '=')
      if (start != -1) {
        start = start + key.length + 1 //最后这个+1其实就是表示"="号啦，这样就获取到了cookie值的开始位置
        //其实我刚看见indexOf()第二个参数的时候猛然有点晕，后来想起来表示指定的开始索引的位置...这句是为了得到值的结束位置。
        //因为需要考虑是最后一项，所以通过";"号是否存在来判断
        let end = document.cookie.indexOf(';', start)
        if (end == -1) end = document.cookie.length
        //通过substring()得到了值。想了解unescape()得先知道escape()是做什么的，都是很重要的基础，
        //想了解的可以搜索下，在文章结尾处也会进行讲解cookie编码细节
        return unescape(document.cookie.substring(start, end)) 
      }
    }
    return ''
  },

  /**
   * 删除指定cookie
   * @param {*} key
   */
  remove(key,path='/',domain) {
    this.set(key, '', -1, path, domain)
  }
}

export default cookieUtil



// WEBPACK FOOTER //
// ./src/api/cookieUtil.js